<div class="subheader with-padding flgrow">
    <div class="row">

        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="relative w-100">
                <ng-select placeholder="{{'lblSelectModuleName' | translate}}" required [(ngModel)]="moduleId" (change)="onFeatureSelect($event)">
                    <ng-option *ngFor="let item of featureList" [value]="item.id" >
                        {{item.name}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div class='col-lg-3 col-md-3 col-sm-6'>
            <div class="date">
                <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                [(ngModel)]="bookingDate" (ngModelChange)="onDateRangeChanged($event)" required/>
            </div>
        </div>
        <div
            class="col-xl-6 col-lg-6 col-md-12 relative mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
            <button type="submit" (click)="onClickChangeView(false)"
                [ngClass]="isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class="mr-sm-2"
                translate>lblSATodayView
            </button>
            <button (click)="onClickChangeView(true)"
                [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class=""
                translate>lblSAWeekView
            </button>
            <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
                (click)='refresh()'>
                <em class="fas fa-sync font15 align-middle"></em>
            </a>
        </div>

    </div>
</div>

<div class="container prel">
    <div class="row mt20">
        <div class="c12">
            <div class="card ">
                <div class="card-header d-flex justify-content-between">
                    <h4 class="card-title" translate>
                        lblDMSSyncFailedlog
                    </h4>
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                            totalCount
                            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                      </div>  
                </div>
                <div class="table-responsive  max-h232"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="throttle"
                [scrollWindow]="false"
                (scrolled)="onScrollDown($event)" >
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 55px">#</th>
                                <th scope="col" sortable="moduleName" (sort)="onSort($event)" translate>lblFeatureName
                                </th>
                                <th scope="col" style="width: 200px" translate>lblName
                                </th>
                                <th scope="col" translate>lblUrl</th>
                                <th scope="col" 
                                    translate>lblException</th>
                                <th scope="col"  translate>lblCreatedBy
                                </th>
                                <th scope="col" sortable="createDate" (sort)="onSort($event)" translate>lblDate</th>
                                <th class="text-center" scope="col" translate>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="dmsLogList?.length>0; else load_else">
                                <tr *ngFor="let mechanic of dmsLogList; let i=index">
                                    <td>{{ mechanic.rowNumber }}</td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.moduleName">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.referenceName">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.apiUrl">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.responseStatusCode" >
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.createdByName" >
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="mechanic.createDate| date : 'short'" >
                                        </ngb-highlight>
                                    </td>


                                    <td class="nowrap text-center">
                                        <!-- View Exception Button -->
                                        <a class="ml-2 btn btn-ico" 
                                           ngbTooltip="{{'lblViewException' | translate}}"  
                                           tooltipClass="custom-revert"
                                           (click)="viewException(mechanic)" 
                                           translate>
                                            <em class="fa fa-eye fa-lg"></em>
                                        </a>
                                        
                                        <!-- Check if integration with DMS is enabled and hideButtons is false -->
                                        <span class="ico-div" *ngIf="integrationWithDMS && !hideButtons"></span>
                                        
                                        <!-- Sync to DMS Button -->
                                        <span *ngIf="integrationWithDMS && !hideButtons">
                                            <a class="ml-2 btn btn-ico" 
                                               ngbTooltip="{{ 'lblSyncToDMS' | translate }}"  
                                               tooltipClass="custom-revert"
                                               *ngIf="mechanic.syncStatus == 0" 
                                               (click)="onSyncToDms(mechanic.moduleId, mechanic.referenceId, mechanic.referenceName)" 
                                               translate>
                                                <em class="fas fa-sync fa-lg"></em>
                                            </a>
                                        </span>
                                        
                                        <!-- Success Message -->
                                        <span *ngIf="mechanic.syncStatus == 1 && !hideButtons" translate>
                                            lblSuccess
                                        </span>
                                    </td>
                                    
                                    
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>

                </div>
            </div>

        </div>
    </div>

</div>